import { render, staticRenderFns } from "./LikertOptionForm.vue?vue&type=template&id=0d483bc4"
import script from "./LikertOptionForm.vue?vue&type=script&lang=js"
export * from "./LikertOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports